// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"56b6def9","455":"52e186bb","977":"5aced792"}[chunkId] + ".chunk.js";
};